document.addEventListener('DOMContentLoaded', () => {
  // Select all elements with the class instead of just the first one
  const searchContainers = document.querySelectorAll('.predictive-search--header');
  let lastScrollTop = 0;

  window.addEventListener('scroll', () => {
      const currentScrollTop = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;

      // Loop through all matching elements
      searchContainers.forEach(container => {
          if (currentScrollTop > 100) {
              container.classList.add('scrolled-search');
              container.classList.remove('custom-default-search');
          } else {
              container.classList.remove('scrolled-search');
              container.classList.add('custom-default-search');
          }
      });

      lastScrollTop = currentScrollTop;
  });
});

